import { hMacAjax } from '../../httpService';
import { userCenterAPI } from '@/httpService/serviceApi';

export const url = {
    welcome: `${userCenterAPI}/open/ai/course/preset-questions`
};

export enum COURSE_TYPE {
    /** 点播课 */
    DEMOND = '1',
    /** 其他业务 */
    BIZ = '2'
}

export interface RequestData {
    /**
     * 课程id（点播课传课程id，视频课传业务id）
     */
    course_id?: string;
    /**
     * 课程类型 1点播课 2视频课，开放课
     */
    course_type?: COURSE_TYPE;
}

export interface ResponseData<T> {
    success: boolean,
    code: string,
    msg: string,
    data: T
}

export interface DataItem {
    /** 问题 */
    question: string;
    /** 视频id */
    vid: number;
}


//获取预设问题
export function handleWelcome(data: RequestData): Promise<ResponseData<DataItem[]>> {
    //@ts-ignore
    return hMacAjax.get(url.welcome, data);
}
